























































































































import mixins from 'vue-typed-mixins';
import { mapGetters } from 'vuex';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { SearchPayload, NotesPayload } from '@/Stores/AppealStore';
import { SearchParams } from '@/Appeals/Citation/SearchParams';
import VatsAPI from '@/Shared/VatsAPI';
import NoteTypeLkupsDropdown from '@/Shared/NoteTypeLkupsDropdown.vue';
import AttachmentList from './AttachmentList.vue';
import { Note } from './Note';
import { Attachment } from './Attachment';
import { TranslateResult } from 'vue-i18n';

const saveMsgBoxOptions = {
    centered: true,
    okVariant: 'success',
    hideBackdrop: true
};

export default mixins(LocationBasedMixin).extend({
    props: {
        editNotes: {
            type: Boolean,
            default: false,
            required: true
        },
        addNotes: {
            type: Boolean,
            default: false,
            required: true
        },
    },
    data() {
        return {
            editNotesInternal: false,
            addNotesInternal: false,
            newNote: new Note(),
            newFile: (undefined as unknown) as File,
        };
    },
    components: {
        NoteTypeLkupsDropdown,
        AttachmentList,
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress',
            'searchParams',
            'getSearchResults',
            'notesLoaded',
            'getNotes'
        ]),
        attachments(): Attachment[] {
            const attachments = Array<Attachment>();
            for (const x of this.getNotes) {
                if (x.hasOwnProperty('attachment')
                  && x.attachment !== undefined
                  && x.attachment !== null) {
                  attachments.push(x.attachment);
                }
            }
            return attachments;
        },
    },
    mounted() {
        this.$root.$on('bv::modal::hide', (bvEvent: any, modalId: any) => {
            if (modalId === 'modal-add-notes') {
                this.$emit('addNotesEvent', false);
            }

            if (modalId === 'modal-edit-notes') {
                this.$emit('editNotesEvent', false);
            }
        });

        this.$root.$on('bv::modal::show', (bvEvent: any, modalId: any) => {
            if (modalId === 'modal-add-notes') {
                this.$emit('addNotesEvent', true);
            }

            if (modalId === 'modal-edit-notes') {
                this.$emit('editNotesEvent', true);
            }
        });

        if (!this.getSearchResults.citationNumber) {
            return;
        }
        this.reloadNotes();
    },
    watch: {
        editNotes(value: boolean) {
            this.$data.editNotesInternal = value;
        },
        addNotes(value: boolean) {
            this.$data.addNotesInternal = value;
        }
    },
    methods: {
        async clearChange(item: any) {
            item.noteText = item.originalNoteText;
            item._showDetails = false;
        },
        async saveNote(item: any) {
            if (!this.getSearchResults.citationNumber) {
                return;
            }
            item.userID = this.$typedStore.modules.userModule.getters.userName;
            const payload: NotesPayload = {
                parameters: item,
                location: this.$typedStore.state.currentLocation
            };

            await this.$typedStore.modules.appealModule.actions.updateNote(payload);
            const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
            await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);
            item._showDetails = false;
            this.reloadNotes();
        },
        async saveNewNote(newNote: Note) {
            if (!this.getSearchResults.citationNumber) {
                return;
            }
            if (this.$data.newFile != null && this.$data.newFile !== undefined) {
                const formData = new FormData();
                formData.append('file', this.$data.newFile, this.$data.newFile.name);

                const result = await VatsAPI.post<number>(`/${this.location}/citations/attachment/add`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                newNote.attachmentRecID = result.data;
            }

            newNote.citationRecID = this.getSearchResults.citationNumber;
            newNote.userID = this.$typedStore.modules.userModule.getters.userName!;
            newNote.dateEntered = new Date();

            const payload: NotesPayload = {
                    parameters: newNote,
                    location: this.$typedStore.state.currentLocation
                };
            await this.$typedStore.modules.appealModule.actions.updateNote(payload);
            const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
            await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);

            this.$emit('addNotesEvent', false);
            this.$data.newNote = new Note();
            this.reloadNotes();
            this.$emit('editNotesEvent', true);
        },
        async removeNote(note: any) {
            const payload: NotesPayload = {
                parameters: note.item,
                location: this.$typedStore.state.currentLocation
            };

            await this.$typedStore.modules.appealModule.actions.deleteNote(payload);
            const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
            await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);

            this.reloadNotes();
        },
        async reloadNotes() {
            const searchParams = new SearchParams();
            searchParams.citationNumber = this.getSearchResults.citationNumber;
            searchParams.vehicleState = this.getSearchResults.vehicleState;
            searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;

            const payload: SearchPayload = {
                parameters: searchParams,
                location: this.$typedStore.state.currentLocation
            };
            this.$typedStore.modules.appealModule.actions.loadNotes(payload);
        },
    },
});
